export default {"src":"/_next/static/media/document-duplicate.070abf52.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};